import * as React from 'react';
const SvgProgrammingLanguages = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={640} height={640} viewBox='300 160 80 80' {...props}>
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='M325.537 167.031h39.406l.372.012.365.035.359.058.352.08.344.101.336.121.326.142.317.161.306.179.296.197.284.214.271.231.259.247.245.262.231.276.216.29.201.303.185.316.153.3-.214-.036-.382-.05-.388-.036-.392-.021-.397-.008h-35.087l-.397.008-.393.021-.387.036-.382.05-.376.063-.37.076-.362.089-.356.101-.348.114-.34.125-.332.137-.323.148-.314.159-.304.17-.294.18-.284.189-.273.199-.262.209-.25.217-.238.226-.226.234-.213.243-.199.25-.186.257-.172.264-.158.271-.142.277-.128.283-.111.289-.096.294-.079.3-.062.304-.045.308-.028.313-.009.316.009.317.028.312.045.309.062.304.079.299.096.294.111.289.128.283.142.278.158.27.172.265.186.257.199.25.213.242.226.234.238.226.25.218.262.208.273.199.284.19.294.18.304.169.314.159.323.148.332.137.34.126.348.113.356.102.362.089.37.076.376.063.382.049.387.036.393.022.397.007h35.087l.397-.007.392-.022.388-.036.382-.049.376-.063.369-.076.148-.037v33.613l-.011.397-.033.39-.054.384-.075.376-.095.367-.113.359-.133.348-.15.339-.168.327-.185.316-.201.303-.216.29-.231.276-.245.262-.259.247-.271.23-.284.215-.296.197-.306.179-.317.161-.326.142-.336.121-.344.101-.352.08-.359.058-.365.035-.372.012h-39.406l-.372-.012-.365-.035-.359-.058-.352-.08-.344-.101-.336-.121-.326-.142-.317-.161-.306-.179-.296-.197-.284-.215-.271-.23-.259-.247-.245-.262-.231-.276-.216-.29-.201-.303-.185-.316-.168-.327-.15-.339-.133-.348-.113-.359-.095-.367-.075-.376-.054-.384-.033-.39-.011-.397v-43.626l.011-.396.033-.391.054-.383.075-.376.095-.367.113-.359.133-.348.15-.339.168-.327.185-.316.201-.303.216-.29.231-.276.245-.262.259-.247.271-.231.284-.214.296-.197.306-.179.317-.161.326-.142.336-.121.344-.101.352-.08.359-.058.365-.035.372-.012'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='M11.614 0 0 9.86l11.667 8.883'
      transform='matrix(1.13147 0 0 1.27157 322.314 190.085)'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeLinejoin='bevel'
      strokeWidth={1.2}
      d='M11.614 0 0 9.86l11.667 8.883'
      transform='matrix(-1.13147 0 0 1.27157 368.7 190.085)'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeMiterlimit={2}
      strokeWidth={1.2}
      d='M8.396 0 0 16.862'
      transform='matrix(1.13147 0 0 1.27157 340.884 190.303)'
    />
    <path
      fill={props.fill || 'none'}
      stroke={props.stroke || 'tan'}
      strokeLinecap='square'
      strokeMiterlimit={2}
      strokeWidth={1.2}
      d='M366.564 170.724v12.888M339.411 173.609h26.173M331.897 177.18h34.485M339.22 180.437h26.174'
    />
  </svg>
);
export default SvgProgrammingLanguages;
